import { arrayMap } from "./array.utils";

// quotation edit formatter
export function quotationFormatter(editItem) {
  const parseAttachement = editItem?.attachment ? JSON.parse(editItem.attachment) : null;

  const customer = {
    profile: {
      name: parseAttachement?.customer?.name ?? "",
      mobile: parseAttachement?.customer?.mobile ?? "",
      email: parseAttachement?.customer?.email ?? "",
      designation: parseAttachement?.customer?.designation ?? "",
      id: parseAttachement?.customer?.customer_id ?? "",
      account_name: parseAttachement?.customer?.account_name ?? ""
    },
    address: parseAttachement?.customer?.address ?? "",
    loan: {
      bank_name: parseAttachement?.customer?.bank_name ?? "",
      branch_name: parseAttachement?.customer?.branch_name ?? "",
      bank_will_pay: parseAttachement?.customer?.bank_will_pay ?? "",
      customer_will_pay: parseAttachement?.customer?.customer_will_pay ?? "",
      unit_price: parseAttachement?.customer?.unit_price ?? "",
      pay_order_collector_name: parseAttachement?.customer?.pay_order_collector_name ?? ""
    },
    delivery: {
      delivery_services: parseAttachement?.customer?.delivery_services ?? "",
      delivery_papers: parseAttachement?.customer?.delivery_papers ?? "",
      expected_delivery_date: parseAttachement?.customer?.expected_delivery_date ?? ""
    }
  };

  let car = null;

  function handleCarFormat(data) {
    if (!data) return null;

    const features = data?.descriptions ? data?.descriptions?.split(",") : [];

    const result = {
      ...data,
      fullChassis: data?.chassis,
      features,
      id: data?.id ?? data?.stock_list_id
    };

    return result;
  }

  if (editItem?.is_multi && parseAttachement?.car?.length) {
    car = arrayMap(parseAttachement?.car, (item) => handleCarFormat(item));
  } else {
    car = handleCarFormat(parseAttachement?.car);
  }

  const result = editItem?.id
    ? {
        customer,
        car,
        id: editItem?.id ?? "",
        caid: editItem?.caid ?? "",
        cid: editItem?.customer?.customer_id ?? "",
        qoutDate: parseAttachement?.qoutDate ?? "",
        validUntil: parseAttachement?.validUntil ?? "",
        amount: parseAttachement?.amount,
        is_multi: editItem?.is_multi ?? "",
        type_id: editItem?.type_id ?? ""
      }
    : null;

  return result;
}
